
export const STEP_NUMBERS = {
    TEST_ASSIGNMENTS:{number:0},
    SKILL_SELECT:{number:1},
    SKILL_RESOURCE_SELECT:{number:2},
    ASSIGNED_FOLLOW_UP_WORK:{number:3}
}